import { FieldTypeDisplay } from 'api/field-sections/types';
import { unreachable } from 'utils/unreachable';
import { FieldType, FilterableField } from '../fields';
import { FieldFilter } from '../filters';
import { BooleanFilterOperationType } from '../filters/boolean';
import { DateFieldFilterOperationType } from '../filters/date';
import {
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from '../filters/estimate';
import { NumberFilterOperationType } from '../filters/number';
import { SelectFilterOperationType } from '../filters/select';
import { TextFieldFilterOperationType } from '../filters/text';

export const getDefaultCriteria = (field: FilterableField): FieldFilter => {
  switch (field.type) {
    case FieldType.Boolean:
      return { field, type: BooleanFilterOperationType.IsTrue };
    case FieldType.Estimate:
      return {
        field,
        type: EstimateFieldFilterOperationType.IsMoreThan,
        direction: EstimateRelativeDirection.Early,
        days: 0,
      };
    case FieldType.Number:
      return { field, type: NumberFilterOperationType.IsGreaterThan };
    case FieldType.Text:
    case FieldType.MultiLineText:
      return { field, type: TextFieldFilterOperationType.Contains };
    case FieldType.Date:
      // This is a dirty hack just for automations matching conditions, if u r angry I cant help
      if (field?.metaData?.showAllOps === true) {
        return {
          field,
          type: DateFieldFilterOperationType.IsEmpty,
        };
      }

      return {
        field,
        type: DateFieldFilterOperationType.IsToday,
      };
    case FieldType.SingleSelect:
      if (field.fieldName === 'taskDependencyStatus') {
        return {
          field,
          type: SelectFilterOperationType.IsOneOf,
          value: undefined,
        };
      }
      if (field.fieldTypeDisplay === FieldTypeDisplay.Level) {
        return {
          field,
          type: SelectFilterOperationType.IsAtLeast,
          value: undefined,
        };
      }

      return {
        field,
        type: SelectFilterOperationType.Is,
        value: undefined,
      };
    case FieldType.MultiSelect:
      return { field, type: SelectFilterOperationType.Is, value: [] };
    case FieldType.SingleUser:
      return { field, type: SelectFilterOperationType.IsOneOf, value: [] };
    case FieldType.MultiUser:
      return { field, type: SelectFilterOperationType.Is, value: [] };
    case FieldType.Assignee:
      return { field, type: SelectFilterOperationType.IsOneOf, value: [] };
    case FieldType.Note:
      return {
        field,
        type: TextFieldFilterOperationType.Contains,
      };
    default:
      return unreachable(field);
  }
};
